module.exports = [{
      plugin: require('../node_modules/gatsby-source-yotpo-shopify/gatsby-browser.js'),
      options: {"plugins":[],"shopName":"yield-design-llc","shopifyAccessToken":"bde4aef5bae5a75de947b4edb8a69762","yotpoAppKey":"VEaZTa3ecictGXz39HQ5oK5HZWonNi3hUCs9tDt6","appendDefaultObject":false,"createDefaultObject":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Pattern Brands","short_name":"PB","start_url":"/","background_color":"#F0EBE5","theme_color":"#0B474B","display":"minimal-ui","icon":"src/assets/images/yd-favicon-512x512.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"8f76bcb42fda27d7dcb136245bce1a13"},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-loadable-components-ssr/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
